import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

const getApiBaseUrl = () => {
	const hostname = window && window.location && window.location.hostname;
	if (hostname === 'admin.mappes.io') {
		return 'https://adminapi.mappes.io/api';
	} else {
		if (hostname == 'localhost') {
			return 'http://localhost:5000/api';
		} else {
			return 'https://devapiadmin.mappes.io/api';
		}
	}
}

export const APP_NAME = 'Emilus';
// export const API_BASE_URL = env.API_ENDPOINT_URL
export const API_BASE_URL = getApiBaseUrl()
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR
};